import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';

export default function IndexDynamic({}: any) {
    return (
        <>
            <B />
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            {/* 6.14不上线，6.25再上线 */}
            <I />
        </>
    );
}
